import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ShortId from 'shortid';
import { SquareButton, SquareGhostButton } from '@hobs/components/Buttons';
import PropTypes from 'prop-types';
import Styles from './WithAnnexFilter.module.scss';

const WithAnnexFilter = Component => {
  class AnnexFilter extends PureComponent {
    state = {
      selected: null
    };

    toggleAnnex = (annex, callback) => {
      let selected = this.state.selected;
      if (selected === annex.annexId) {
        selected = null;
      } else {
        selected = annex.annexId;
      }

      this.setState(
        {
          selected
        },
        () => {
          callback(this.state.selected, annex);
        }
      );
    };

    resetFilter = callback => {
      this.setState(
        {
          selected: null
        },
        () => {
          callback(this.state.selected, null);
        }
      );
    };

    formateOdataFilter = fieldName => {
      return {
        logic: 'or',
        filters: [
          {
            field: fieldName,
            operator: 'eq',
            value: `<guid>${this.state.selected}</guid>`
          }
        ]
      };
    };

    renderAnnexesFilterForm = (onSelect = () => {}, preselectedAnnex = null) => {
      const AllButton = this.state.selected ? SquareGhostButton : SquareButton;
      if (preselectedAnnex && this.state.selected !== preselectedAnnex.annexId) {
        this.toggleAnnex(preselectedAnnex, onSelect);
      }

      return (
        <div className={Styles['annexes-filter']}>
          <AllButton
            onClick={() => {
              this.resetFilter(onSelect);
            }}
            type="button"
            key={ShortId.generate()}
          >
            {this.props.t('All')}
          </AllButton>

          {this.props.annexes
            .map(annex => {
              const Button =
                this.state.selected === annex.annexId
                  ? SquareButton
                  : SquareGhostButton;

              return (
                <Button
                  type="button"
                  onClick={() => {
                    this.toggleAnnex(annex, onSelect);
                  }}
                  key={annex.annexId}
                >
                  {annex.name}
                </Button>
              );
            })}
        </div>
      );
    };

    render() {
      return (
        <Component
          {...this.props}
          withAnnexFilterSelected={this.state.selected}
          withAnnexFilterOdata={this.formateOdataFilter}
          withAnnexFilterForm={this.renderAnnexesFilterForm}
        />
      );
    }
  }

  AnnexFilter.propTypes = {
    annexes: PropTypes.array,
    t: PropTypes.func
  };

  return AnnexFilter;
};

const mapStateToProps = state => ({
  annexes: state.annex.list
});

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  WithAnnexFilter
);
